import React from 'react';
import { Link } from 'react-router-dom';
import { RefreshCw, Home, LogOut } from 'lucide-react';

interface HeaderProps {
  insurerName: string;
  userEmail: string;
  requestCount: number;
  filter: string;
  isRefreshing: boolean;
  showHiddenRequests: boolean;
  onFilterChange: (filter: string) => void;
  onToggleHidden: () => void;
  onRefresh: (setLoading?: boolean) => void;
  onSignOut: () => void;
  stats: {
    awaitingBids: number;
    inProgress: number;
    noBidsFromUs: number;
  };
}

export function Header({
  insurerName,
  userEmail,
  requestCount,
  filter,
  isRefreshing,
  showHiddenRequests,
  onFilterChange,
  onToggleHidden,
  onRefresh,
  onSignOut,
  stats
}: HeaderProps) {
  return (
    <div className="bg-white shadow-sm -mx-4 sm:-mx-6 lg:-mx-8 mb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
      <div className="flex flex-col md:flex-row md:items-center justify-between">
        <div className="flex items-center space-x-4">
          <a href="/" className="text-gray-600 hover:text-gray-900">
            <Home className="h-5 w-5" />
          </a>
          <h1 className="text-2xl font-bold text-gray-900">Insurer Dashboard</h1>
          {insurerName && (
            <span className="text-sm text-gray-500">
              {insurerName}
            </span>
          )}
        </div>

        <div className="flex items-center space-x-6">
          <div className="flex items-center space-x-4">
            <span className="text-gray-600">Total Requests: {requestCount}</span>
            <button
              onClick={() => onRefresh(true)}
              className="p-2 text-gray-600 hover:text-gray-900 rounded-full hover:bg-gray-100 transition-colors"
              disabled={isRefreshing}
              title="Refresh requests"
            >
              <RefreshCw className={`h-5 w-5 ${isRefreshing ? 'animate-spin' : ''}`} />
            </button>
          </div>

          <div className="flex items-center space-x-4">
            <Link
              to="/insurer/profile"
              className="px-3 py-1.5 rounded-md bg-blue-100 text-blue-800 hover:bg-blue-200 transition-colors"
            >
              Company Profile
            </Link>
            <span className="text-gray-600">{userEmail}</span>
            <button
              onClick={async () => {
                try {
                  await onSignOut();
                } catch (error) {
                  console.error('Error signing out:', error);
                }
              }}
              className="flex items-center text-gray-600 hover:text-gray-900"
            >
              <LogOut className="h-5 w-5 mr-2" />
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
}